import { DEFAULT_LANGUAGE, resources } from '@anywayseo/tools';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

i18n.use(initReactI18next).init({
  lng: process.env.GATSBY_SITE_LANGUAGE ?? DEFAULT_LANGUAGE,
  fallbackLng: {
    default: [DEFAULT_LANGUAGE],
  },
  resources,
});

export default i18n;
